import {Link} from 'react-router-dom'
import {useIntl} from 'react-intl'
import BulkCard from './add-bulk/BulkCard'
import './add-bulk/add-products-bulk.css'

// No tutorial video exists for Add Products - Bulk yet. Drop the URL here and
// the "Watch Tutorial" button (per the new design) lights up automatically.
const TUTORIAL_URL = ''

const AddBulk = () => {
  const {formatMessage} = useIntl()

  return (
    <div className='apb-root'>
      <div className='apb-header'>
        <Link to='/request-add-products' className='apb-breadcrumb'>
          <i className='fas fa-arrow-left' aria-hidden='true' />
          {formatMessage({id: 'add_single_product'})}
        </Link>
        <div className='apb-header-row'>
          <h1 className='apb-title'>{formatMessage({id: 'add_product_bulk'})}</h1>
          {TUTORIAL_URL && (
            <a className='apb-tutorial-btn' href={TUTORIAL_URL} target='_blank' rel='noopener noreferrer'>
              <i className='fas fa-circle-play' aria-hidden='true' />
              {formatMessage({id: 'watch_tutorial'})}
            </a>
          )}
        </div>
      </div>

      <BulkCard />
    </div>
  )
}

export default AddBulk
